<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.message')"
    namespace=""
    resource="messages"
    :actionColumnProps="{ width: 200 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash'

@Component
export default class Messages extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const isMerchantRole = this.$root.user.current_role.role.kind === 'merchant'

    return [
      {
        prop: 'content_cont',
        label: this.$t('message.content'),
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'product_id_eq',
        label: this.$t('message.product'),
        renderCell: {
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/products', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name || id }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/products', { params });
              return data.map(({ id, name }) => ({ value: id, label: name || id }));
            }
          }
        }
      },
      isMerchantRole && {
        prop: 'is_read_not_eq',
        label: this.$t('message.unread'),
        renderCell: {
          component: 'switch'
        }
      },
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    const isMerchantRole = this.$root.user.current_role.role.kind === 'merchant'

    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'user.member',
        label: this.$t('member.name'),
        renderCell: (h, { props: { value } }) => {
          return <bean-link keepNode to={{ name: 'members.show', params: { id: value.id } }}>{_.get(value, 'name')}</bean-link>
        }
      },
      {
        prop: 'user.member.email',
        label: this.$t('member.email'),
      },
      {
        prop: 'user.member.wechat',
        label: this.$t('member.wechat'),
      },
      {
        prop: 'product',
        label: this.$t('message.product'),
        renderCell: (h, { props: { value } }) => {
          return <bean-link keepNode to={{ name: 'products.show', params: { id: value.id } }}>{_.get(value, 'name', value.id)}</bean-link>
        }
      },
      {
        prop: 'content',
        label: this.$t('message.content')
      },
      isMerchantRole && {
        prop: 'is_read',
        label: this.$t('message.isRead'),
        renderCell: 'bool',
        width: 80,
      },
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return []
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handleMarkRead = async () => {
      await this.$autoLoading(this.$request.put(`/messages/${row.id}/mark_read`));
      this.$message.success(this.$t('bean.updateSuccess'));
      reload();
    }

    return [
      !row.is_read && {
        component: 'confirmButton',
        props: {
          label: this.$t('message.markRead'),
          type: 'primary',
          can: 'messages.mark_read'
        },
        on: {
          confirm: handleMarkRead
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'messages.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

}


export const route = [
  {
    path: '/messages',
    name: 'messages.index',
    component: Messages,
    props: {
      type: 'index',
    }
  },
  {
    path: '/messages/:id',
    name: 'messages.show',
    component: Messages,
    props: {
      type: 'show',
    }
  },
]
</script>
